module.exports = __webpack_public_path__ + "static/media/intro-photowall-17.f152bae9.jpg";